export const CONTENT_OVERVIEW_ROUTES = {
  challenge: '/admin/challenges',
  event: '/admin/classes',
  guide: '/admin/guides',
  path: '/admin/paths',
  scorm: '/admin/content/scorm',
  resource: '/admin/resources',
  content_provider_content: '/admin/content/content_provider_content',
} as const;
